import { render, staticRenderFns } from "./NotificationTemplatesSelect.vue?vue&type=template&id=7f9e2fbf"
import script from "./NotificationTemplatesSelect.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplatesSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports